import warrantyImg from "@/assets/warranty.png";

export const Warranty = () => {
  return (
    <section className="pb-20 relative">
      <div className="container px-4">
        <div className="text-center mb-16 animate-slide-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Garantia incondicional de
            <br />
            <span className="bg-gradient-accent bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(100,192,242,0.6)]">
              7 dias
            </span>
          </h2>

          <p className="text-base sm:text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Você tem 7 dias completos para acessar o método, assistir a vídeo
            aula, aplicar as técnicas e sentir a diferença no seu dia a dia.{" "}
            <br />
            <span className="bg-gradient-accent bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(100,192,242,0.6)]">
              Se dentro desse prazo você achar que o conteúdo não te ajudou como
              deveria, é só pedir seu reembolso. Sem perguntas, sem burocracia,
              sem risco.
            </span>
          </p>
        </div>

        <img
          src={warrantyImg}
          alt="Garantia de 7 dias"
          className="w-full max-w-md mx-auto transition-all duration-700 animate-pulseZoom"
        />
      </div>
    </section>
  );
};
